module.exports = __webpack_public_path__ + "img/t2-11.2df91f56.svg";